/**
 * @file
 */

import { CreateTHEADSectionGV } from "@/common/common.js";
import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeAddLoanPages() {

   // ----------------------------------------------------------------------
   // initialize the validation engine
   // ----------------------------------------------------------------------
   var onSubmit = false;
   customValidationInit(onSubmit);
   aspControlValidationInit();

   // -------------------------------------------------------------------------------------------
   // create the thead section for the gridView since gridView don't natively have it.
   //    this is mainly for ADA
   // -------------------------------------------------------------------------------------------
   CreateTHEADSectionGV("gvLoansToAdd");
   CreateTHEADSectionGV("gvEnrolledLoans");

   $('.responsiveTable').DataTable({
      "responsive": true,
      "scrollX": false,
      "paging": false,
      "searching": false,
      "ordering": false,
      "info": false

   });

   // ----------------------------------------------------------------------
   // Set up a click event on the loans   _N_O_T_   enrolled grid.
   // Use a button having text of check/uncheck to set checkboxes
   // define a button with a class of check
   // determine current checked state and either set or unset checkboxes
   //  with a class of cbAddLoans
   // ----------------------------------------------------------------------
   $('.cbAddLoans:button').click(function () {
      // ------------------------------------------------------------------
      // get current state of check all / uncheck all ctrl then toggle it. 
      // N.B. state is held in data variable named 'checked'.
      //      and text of the control is held in the $(this).val object
      // ------------------------------------------------------------------
      var checked = !$(this).data('checked');
      $(this).val(checked ? 'Uncheck All' : 'Check   All')
      $(this).data('checked', checked);

      // -----------------------------------------------------
      // only modify checkboxes that are not disabled
      // -----------------------------------------------------
      $(".loansToAdd  input[type='checkbox']").each(function () {
         if (!$(this as HTMLInputElement)[0].disabled)
         {
            $(this).prop('checked',checked);
         }

      });
   });

   // ----------------------------------------------------------------------
   // Set up a change event on the checkboxes in loans enrolled grid.
   // Only allow one checkbox to be checked at one time.
   // ----------------------------------------------------------------------
   $('.cbSelectEFT input[type=checkbox]').on('change', function (e) {
      $('.cbSelectEFT input[type=checkbox]').not(this).prop('checked', false);
   });
};
